import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserLogin from '../components/menu-bar/user-login.jsx';
import { goLogin, isEmptyObject } from '../lib/tool';
import { isJustLogined } from '../reducers/user-info';
import pubSub from '../lib/pub-sub';

class UserLoginWraper extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            "loginHandle"
        ])
    }
    componentDidMount(){
        pubSub.subscribe('login', this.loginHandle)
    }
    loginHandle() {
        const { saveWorkToLocalStorage, isJustLogined } = this.props;
        saveWorkToLocalStorage().then(() => {
            isJustLogined(true);
            goLogin();
        })
    }
    componentWillUnmount(){
        pubSub.unsubscribe('login');
    }
    render() {
        const { className, user } = this.props;
        const isLogin = !isEmptyObject(user);
        const username = isLogin && user.username || 'vipJr';
        const userLoginProps = {
            className: classNames(className),
            isLogin,
            username,
            loginHandle: this.loginHandle
        };
        return (<UserLogin {...userLoginProps}></UserLogin>);
    }
}

const mapStateToProps = (state) => ({ user: state.session.session.user });

const mapDispatchToProps = dispatch => ({
    isJustLogined: boolean => dispatch(isJustLogined(boolean))
});

UserLoginWraper.defaultProps = {
    isLogin: false
}

UserLoginWraper.propTypes = {
    className: PropTypes.string,
    isLogin: PropTypes.bool,
    username: PropTypes.string,
    loginHandle: PropTypes.func,
    saveWorkToLocalStorage: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserLoginWraper);
